import { EnvironmentUrls } from 'Roblox';

const { apiGatewayUrl } = EnvironmentUrls;

const createCodeUrlConfig = () => ({
  retryable: true,
  url: `${apiGatewayUrl}/auth-token-service/v1/login/create`
});

const pullCrossDeviceLoginStatusUrlConfig = () => ({
  retryable: true,
  url: `${apiGatewayUrl}/auth-token-service/v1/login/status`
});

const cancelCrossDeviceLoginCodeUrlConfig = () => ({
  retryable: true,
  url: `${apiGatewayUrl}/auth-token-service/v1/login/cancel`
});

export {
  createCodeUrlConfig,
  pullCrossDeviceLoginStatusUrlConfig,
  cancelCrossDeviceLoginCodeUrlConfig
};
